module.exports = __webpack_public_path__ + "static/img/alliance-logo2-3.4f34f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/alliance-logo2-3.png
// module id = h2bE
// module chunks = 0